import { render, staticRenderFns } from "./musicManagement.vue?vue&type=template&id=a3edf156&scoped=true"
import script from "./musicManagement.vue?vue&type=script&lang=js"
export * from "./musicManagement.vue?vue&type=script&lang=js"
import style0 from "./musicManagement.vue?vue&type=style&index=0&id=a3edf156&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3edf156",
  null
  
)

export default component.exports